import { render, staticRenderFns } from "./toTop.vue?vue&type=template&id=a810c6a2&scoped=true"
import script from "./toTop.vue?vue&type=script&lang=js"
export * from "./toTop.vue?vue&type=script&lang=js"
import style0 from "./toTop.vue?vue&type=style&index=0&id=a810c6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a810c6a2",
  null
  
)

export default component.exports